import React, { Component } from "react";
import { Link } from 'react-router-dom';
import AppUrl from '../../restApi/AppUrl';
import IRestClient from '../../restApi/IRestClient';
import Wentwrong from "../Wentwrong/Wentwrong";
import { FaPlay, FaHandHoldingHeart, FaChevronRight, FaTimes, FaEnvelope } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

/*
  Hero height strategy
  ─────────────────────────────────────────────────────────────
  100vh  : fallback for old browsers
  100svh : "small viewport height" — excludes mobile browser chrome
           (iOS Safari address bar, Android Chrome toolbar).
           Without this, content near the bottom gets clipped behind
           the browser UI on phones.
  Both values are set via the CSS class .hero-banner so the cascade
  handles the override automatically.

  Image art-direction (served via <picture>)
  ─────────────────────────────────────────────────────────────
  Mobile  < 640 px  → banner_image_sm   768×1024  WebP  portrait 3:4
                       ~75 % less data than desktop, perfect portrait fit
  Tablet  640–1279  → banner_image_md   1280×800  WebP  landscape 16:10
  Desktop ≥ 1280 px → banner_image      1920×1080 WebP  landscape 16:9

  Fallback chain: each source falls back to the desktop URL if the
  admin hasn't yet re-uploaded since the responsive feature was added.
*/

/* ── Gradient overlay — consistent brand dark tint ─────── */
const GRADIENT = 'linear-gradient(160deg, rgba(10,20,40,0.80) 0%, rgba(16,35,65,0.65) 55%, rgba(10,20,40,0.55) 100%)';

class Topbanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myData:       [],
      modalVideoSrc: '',
      error:        false,
      loading:      true,
      currentSlide: 0,
    };
  }

  componentDidMount() {
    IRestClient.GetRequest(AppUrl.homebanner).then(result => {
      if (result == null) {
        this.setState({ error: true, loading: false });
      } else {
        this.setState({ myData: result, loading: false });
        if (result.length > 1) this.startAutoSlide(result.length);
      }
    }).catch(() => this.setState({ error: true, loading: false }));
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    document.body.style.overflow = '';
  }

  startAutoSlide = (total) => {
    this.interval = setInterval(() => {
      this.setState(prev => ({
        currentSlide: (prev.currentSlide + 1) % total,
      }));
    }, 5000);
  };

  goToSlide = (index) => {
    clearInterval(this.interval);
    this.setState({ currentSlide: index }, () => {
      this.startAutoSlide(this.state.myData.length);
    });
  };

  openModal  = (src) => { this.setState({ modalVideoSrc: src }); document.body.style.overflow = 'hidden'; };
  closeModal = ()    => { this.setState({ modalVideoSrc: '' });  document.body.style.overflow = 'auto';   };

  render() {
    const { myData, currentSlide, modalVideoSrc, loading, error } = this.state;

    /* ── Loading skeleton ─────────────────────────────────── */
    if (loading) {
      return (
        <>
          <style>{`.hero-banner{height:70vh;height:70svh;min-height:480px;}@media(min-width:640px){.hero-banner{height:100vh;height:100svh;min-height:unset;}}`}</style>
          <div className="hero-banner relative w-full bg-primary-900 overflow-hidden flex items-center justify-center">
            <div className="text-center w-full max-w-3xl mx-auto px-4">
              <div className="animate-pulse bg-white/10 rounded-full h-6 w-36 mx-auto mb-8" />
              <div className="animate-pulse bg-white/10 rounded-2xl h-14 sm:h-20 w-4/5 mx-auto mb-4" />
              <div className="animate-pulse bg-white/10 rounded-xl h-8 sm:h-10 w-2/3 mx-auto mb-10" />
              <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
                <div className="animate-pulse bg-secondary-600/40 rounded-full h-12 w-40" />
                <div className="animate-pulse bg-white/10 rounded-full h-12 w-40" />
              </div>
            </div>
            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3">
              {[0,1,2].map(i => <div key={i} className="animate-pulse bg-white/20 rounded-full w-3 h-3" />)}
            </div>
          </div>
        </>
      );
    }

    if (error) return <Wentwrong />;

    return (
      <>
        {/*
          hero-banner height:
            height: 100vh  — fallback for browsers without svh support
            height: 100svh — overrides on modern browsers, excludes mobile chrome
        */}
        <style>{`
          /* Mobile: 70svh so the landscape image isn't over-zoomed */
          .hero-banner { height: 70vh; height: 70svh; min-height: 480px; }
          /* Tablet and up: full viewport */
          @media (min-width: 640px) {
            .hero-banner { height: 100vh; height: 100svh; min-height: unset; }
          }

          /* Ensure picture fills its container on all browsers */
          .slide-picture { position: absolute; inset: 0; width: 100%; height: 100%; display: block; }
          .slide-picture img {
            width: 100%; height: 100%;
            object-fit: cover;
            object-position: center top;
            display: block;
          }

          /* Smooth slide transition */
          .slide-item { transition: opacity 1s ease-in-out; }
        `}</style>

        <div className="hero-banner relative w-full overflow-hidden">

          {/* ── Slides ──────────────────────────────────────── */}
          {myData.map((slide, index) => {
            const isActive = index === currentSlide;

            // Responsive sources — fall back to desktop URL if sm/md not yet generated
            const srcDesktop = slide.banner_image    || '';
            const srcTablet  = slide.banner_image_md || srcDesktop;
            const srcMobile  = slide.banner_image_sm || srcDesktop;

            return (
              <div
                key={slide.id}
                className="slide-item absolute inset-0 w-full h-full"
                style={{ opacity: isActive ? 1 : 0, zIndex: isActive ? 1 : 0 }}
                aria-hidden={!isActive}>

                {/* ── Art-directed background image ─────────
                    < 640 px : mobile portrait crop  (768×1024)
                    640-1279 : tablet landscape crop (1280×800)
                    ≥ 1280 px: desktop HD crop       (1920×1080)
                ─────────────────────────────────────────── */}
                <picture className="slide-picture">
                  <source media="(max-width: 639px)"  srcSet={srcTablet}  type="image/webp" />
                  <source media="(max-width: 1279px)" srcSet={srcTablet}  type="image/webp" />
                  <img
                    src={srcDesktop}
                    alt={slide.title || 'SOYAN hero banner'}
                    /* Only the active slide is eager — others lazy-load */
                    loading={isActive ? 'eager' : 'lazy'}
                    decoding="async"
                    fetchpriority={isActive ? 'high' : 'auto'}
                  />
                </picture>

                {/* Gradient overlay */}
                <div
                  className="absolute inset-0 z-10 pointer-events-none"
                  style={{ background: GRADIENT }}
                />

                {/* ── Slide content ─────────────────────── */}
                <div className="relative z-20 flex items-center justify-center h-full px-4 sm:px-6 lg:px-8">
                  <div className="text-center w-full max-w-4xl mx-auto">

                    {/* Badge */}
                    <motion.div
                      className="inline-block mb-4 sm:mb-6"
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: isActive ? 1 : 0, y: isActive ? 0 : 20 }}
                      transition={{ duration: 0.6, delay: 0.1 }}>
                      <span className="inline-flex items-center gap-2 bg-secondary-600/90 text-white text-xs font-bold uppercase tracking-widest px-4 sm:px-5 py-2 rounded-full shadow-lg">
                        <FaHandHoldingHeart className="text-white" />
                        Making a Difference
                      </span>
                    </motion.div>

                    {/* Title */}
                    <motion.h1
                      className="text-3xl sm:text-5xl lg:text-7xl font-black text-white mb-3 sm:mb-5 leading-tight drop-shadow-2xl px-2"
                      initial={{ opacity: 0, y: 40 }}
                      animate={{ opacity: isActive ? 1 : 0, y: isActive ? 0 : 40 }}
                      transition={{ duration: 0.8, delay: 0.2 }}>
                      {slide.title}
                    </motion.h1>

                    {/* Subtitle */}
                    <motion.p
                      className="text-sm sm:text-lg lg:text-xl text-gray-200 mb-6 sm:mb-10 max-w-2xl mx-auto leading-relaxed font-light px-3"
                      initial={{ opacity: 0, y: 30 }}
                      animate={{ opacity: isActive ? 1 : 0, y: isActive ? 0 : 30 }}
                      transition={{ duration: 0.8, delay: 0.35 }}>
                      {slide.short_description}
                    </motion.p>

                    {/* CTA buttons */}
                    <motion.div
                      className="flex flex-col sm:flex-row gap-3 sm:gap-4 items-center justify-center"
                      initial={{ opacity: 0, y: 30 }}
                      animate={{ opacity: isActive ? 1 : 0, y: isActive ? 0 : 30 }}
                      transition={{ duration: 0.8, delay: 0.5 }}>

                      {/* Contact Us — primary CTA */}
                      <motion.div whileHover={{ scale: 1.05, y: -2 }} whileTap={{ scale: 0.97 }}>
                        <Link
                          to="/contact"
                          className="inline-flex items-center gap-2 sm:gap-3 px-7 sm:px-9 py-3.5 sm:py-4 text-white font-bold text-sm sm:text-base rounded-full shadow-2xl transition-all duration-300 border-2"
                          style={{ background: '#2E8B54', borderColor: '#3DAA6B' }}
                          onMouseEnter={e => e.currentTarget.style.background = '#237A4B'}
                          onMouseLeave={e => e.currentTarget.style.background = '#2E8B54'}>
                          <FaEnvelope className="text-base sm:text-lg flex-shrink-0" />
                          Get In Touch
                          <FaChevronRight className="text-xs sm:text-sm" />
                        </Link>
                      </motion.div>

                      {/* Donate Now — hidden until payment goes live */}
                      <motion.div whileHover={{ scale: 1.05, y: -2 }} whileTap={{ scale: 0.97 }} style={{ display: 'none' }}>
                        <Link
                          to="/donate"
                          className="inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 py-3.5 sm:py-4 bg-secondary-600 hover:bg-secondary-700 text-white font-bold text-sm sm:text-base rounded-full shadow-2xl transition-all duration-300 border-2 border-secondary-400">
                          <FaHandHoldingHeart className="text-base sm:text-lg" />
                          Donate Now
                          <FaChevronRight className="text-xs sm:text-sm" />
                        </Link>
                      </motion.div>

                      {slide.video_button && (
                        <motion.div whileHover={{ scale: 1.05, y: -2 }} whileTap={{ scale: 0.97 }}>
                          <button
                            className="inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 py-3.5 sm:py-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-bold text-sm sm:text-base rounded-full border-2 border-white/40 shadow-2xl transition-all duration-300"
                            onClick={() => this.openModal(slide.video_button)}>
                            <div className="w-8 h-8 sm:w-9 sm:h-9 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                              <FaPlay className="text-white text-xs ml-0.5" />
                            </div>
                            Watch Video
                          </button>
                        </motion.div>
                      )}
                    </motion.div>

                  </div>
                </div>
              </div>
            );
          })}

          {/* ── Slide indicators ────────────────────────────── */}
          {myData.length > 1 && (
            <div className="absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 z-30 flex gap-2 sm:gap-3">
              {myData.map((_, index) => (
                <button
                  key={index}
                  onClick={() => this.goToSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                  className={`rounded-full transition-all duration-300 focus:outline-none ${
                    index === currentSlide
                      ? 'bg-secondary-500 w-7 sm:w-8 h-2.5 sm:h-3 shadow-lg'
                      : 'bg-white/40 hover:bg-white/70 w-2.5 sm:w-3 h-2.5 sm:h-3'
                  }`}
                />
              ))}
            </div>
          )}

          {/* ── Video modal ──────────────────────────────────── */}
          <AnimatePresence>
            {modalVideoSrc && (
              <motion.div
                className="fixed inset-0 z-50 flex items-center justify-center p-4"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}>

                <div
                  className="absolute inset-0 bg-black/85 backdrop-blur-sm"
                  onClick={this.closeModal}
                />

                <motion.div
                  className="relative w-full max-w-4xl bg-gray-900 rounded-2xl shadow-2xl overflow-hidden"
                  initial={{ scale: 0.85, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0.85, opacity: 0 }}
                  transition={{ type: 'spring', damping: 25, stiffness: 300 }}>

                  <button
                    className="absolute top-4 right-4 z-10 w-10 h-10 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center text-white transition-all duration-200"
                    onClick={this.closeModal}
                    aria-label="Close video">
                    <FaTimes className="text-lg" />
                  </button>

                  <div className="relative w-full aspect-video">
                    <iframe
                      src={modalVideoSrc}
                      title="SOYAN video"
                      className="w-full h-full"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>

        </div>
      </>
    );
  }
}

export default Topbanner;
